import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=e9fbb5e8&scoped=true&"
import script from "./BillDetail.vue?vue&type=script&lang=js&"
export * from "./BillDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=e9fbb5e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fbb5e8",
  null
  
)

export default component.exports